module.exports = __webpack_public_path__ + "e3cd9624b78613f0d3133388490c89e7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/checkoutWidget/merchant-logo.svg
// module id = 6xNB
// module chunks = 380